import { defineStore } from "pinia";

//공통정보 storage 저장안하는 정보
export const useCommon = defineStore("common", {
  state: () => ({
    loadingFlag: false,
    loadingBarCnt: 0,
    popAlertFlag: false, //alert 팝업 Show유무
    popAlertTitle: "", //alert 팝업 타이틀
    popAlertText: "", //alert 팝업 서브
    popAlertType: "warning", //alert 팝업 타입
    popAlertFunction: function () {}, //alert 팝업 타입
    popConfirmFlag: false, //confirm 팝업 Show유무
    popConfirmTitle: "", //confirm 팝업 타이틀
    popConfirmText: "", //confirm 팝업 서브
    popConfirmOption: {}, //confirm 팝업 옵션
    reloadFlag: false, //새로고침 플래그
    pageParam: {},
    payPopParam: {
      price: "",
      svcGrpId: "",
      svcGrpRateTierId: "",
      mobileFlag: "",
    },
  }),
  getters: {},
  actions: {
    loadingBarClear() {
      this.loadingBarCnt = 0;
      this.loadingFlag = false;
    },
    setPayparam(data) {
      this.$patch((state) => {
        state.payPopParam.price = data.price;
        state.payPopParam.svcGrpId = data.svcGrpId;
        state.payPopParam.svcGrpRateTierId = data.svcGrpRateTierId;
        state.payPopParam.mobileFlag = data.mobileFlag;
      });
    },
  },
  persist: [
    {
      paths: ["pageParam", "payPopParam"],
      storage: localStorage,
    },
  ],
});
